import { getProperty } from '@/common/oldMobile';
import { isEmpty } from 'lodash';

export const isNativeCasinoGameSession = (): boolean => {
    return window.OPTIONS?.casino?.isNativeGameSession;
};

export const nativeRedirectHostName = (): string => {
    return getProperty('nativeRedirectToApp');
};

export const nativeLoginAndOpenCasinoGameDescriptionUrl = (gameId: string) => {
    const redirectURL = isEmpty(gameId) ? '/' : `/casino/game-description/${gameId}`;
    return `${nativeRedirectHostName()}/login?redirectURL=${redirectURL}`;
};

export const nativeOpenCasinoGameDescriptionUrl = (gameId: string) => {
    const redirectURL = isEmpty(gameId) ? '/' : `/casino/game-description/${gameId}`;
    return `${nativeRedirectHostName()}/open?redirectURL=${redirectURL}`;
};

export const nativeCloseCasinoGameAndBackToAppUrl = (gameId: string) => {
    return `/doLogout?redirectURL=${nativeOpenCasinoGameDescriptionUrl(gameId)}`;
};

export const nativeLoginAndOpenIScratchGameUrl = () => {
    return `${nativeRedirectHostName()}/login?redirectURL=/zreby`;
};

export const nativeOpenIScratchPageUrl = () => {
    return `${nativeRedirectHostName()}/open?redirectURL=/zreby`;
};

export const nativeCloseIScratchGameAndBackToAppUrl = () => {
    return `/doLogout?redirectURL=${nativeOpenIScratchPageUrl()}`;
};
